import * as Yup from "yup";

export const validationSchemaCreateVehicle = Yup.object().shape({
  vin: Yup.string().required("Vin is required"),
  immatriculation: Yup.string().required("Immatriculation is required"),
  brand: Yup.string().required("Brand is required"),
  modele: Yup.string().required("Modele is required"),
  gearBox: Yup.string().required("Gearbox is required"),
  fiscalPower: Yup.string().required("Fiscal power is required"),
  energy: Yup.string().required("Energy is required"),
  releaseDate: Yup.string().required("Release date is required"),
  status: Yup.string().required("Status is required"),
  isLeasing: Yup.string().required(
    "Please select whether it is leasing or not"
  ),
});

interface FormValuesVehicle {
  vin: string;
  immatriculation: string;
  brand: string;
  modele: string;
  gearBox: string;
  fiscalPower: string;
  energy: string;
  releaseDate: string;
  status: string;
  isLeasing: string;
}

export const initialValuesVehicle: FormValuesVehicle = {
  vin: "",
  immatriculation: "",
  brand: "",
  modele: "",
  gearBox: "",
  fiscalPower: "",
  energy: "",
  releaseDate: "",
  status: "",
  isLeasing: "",
};
